var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindDirection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9962 4.16788L12.7471 9.1999L11.2515 9.1999V8.7029C11.2515 8.24789 10.8826 7.87903 10.4276 7.87903C9.97259 7.87903 9.60373 8.24789 9.60373 8.7029V9.1999L2.34536 9.1999C1.93349 9.1999 1.59961 9.53378 1.59961 9.94565C1.59961 10.3575 1.93349 10.6914 2.34536 10.6914H9.60373V18.6018H8.97737C8.75645 18.6018 8.57737 18.7809 8.57737 19.0018V20.0129C8.57737 20.2338 8.75645 20.4129 8.97737 20.4129H11.9061C12.127 20.4129 12.3061 20.2338 12.3061 20.0129V19.0018C12.3061 18.7809 12.127 18.6018 11.9061 18.6018H11.2515V10.6914H20.8825C21.5582 10.6914 22.1289 10.2421 22.3122 9.62604H22.3996V6.86945C22.3996 5.10796 20.9716 3.67999 19.2101 3.67999C18.7577 3.67999 18.3228 3.85479 17.9962 4.16788Z",
    fill: "#1E2447"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindDirection);
export default __webpack_public_path__ + "static/media/WindDirection.4baa0faf.svg";
export { ForwardRef as ReactComponent };